function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import TextPartComponent from "/components/core/one-pager/desktop-content/text-part/text-part-component";
import BackgroundTriangleComponent from "/components/enhancements/decorators/background-triangle/background-triangle-component";
import { withAbTests } from "/contexts/ab-tests-context";
import { getAssetPath } from "/services/assets-service";
import classnames from "classnames";
import Picture from "/components/core/picture/picture-component";
import { StyledDesktopContentComponent } from "./desktop-content-component.scss";
class DesktopContentComponent extends PureComponent {
    getSegmentHeight() {
        const { imageWithBackgroundPart } = this.props;
        return imageWithBackgroundPart.imageSegmentHeight || "100vh";
    }
    render() {
        const { textPart, signupForm = {}, collaborationWith, imageWithBackgroundPart } = this.props;
        signupForm.focusOnLoad = true;
        const alignText = imageWithBackgroundPart.imageAlign;
        return /*#__PURE__*/ _jsxs(StyledDesktopContentComponent, {
            className: classnames("desktop-content-component", {
                "straight-border": imageWithBackgroundPart.straightBorder
            }),
            style: {
                height: `calc(${this.getSegmentHeight()} - 65px)`
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-part-wrapper",
                    children: /*#__PURE__*/ _jsx(TextPartComponent, _object_spread_props(_object_spread({}, textPart), {
                        signupForm: signupForm,
                        collaborationWith: collaborationWith
                    }))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "image-wrapper",
                    children: [
                        /*#__PURE__*/ _jsx(BackgroundTriangleComponent, {
                            borderColor: imageWithBackgroundPart.backgroundColor,
                            straightBorder: imageWithBackgroundPart.straightBorder
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: classnames("image-part-wrapper", alignText),
                            children: /*#__PURE__*/ _jsx(Picture, {
                                src: getAssetPath(imageWithBackgroundPart.src),
                                alt: imageWithBackgroundPart.alt
                            })
                        })
                    ]
                })
            ]
        });
    }
}
export default withAbTests(DesktopContentComponent);
